<div class="message">
  <p class="header">Trying to launch the Mitel App.</p>
  <p>If you do not have it installed, please contact your system administrator or go to <a href="https://oneview.mitel.com/s/support" target="_blank">OneView</a> for support. For general questions, please contact <a href="https://www.mitel.com/contact" target="_blank">Contact Mitel</a>.</p>
</div>
